import { render, staticRenderFns } from "./client-type-update.vue?vue&type=template&id=7e4b6578&"
import script from "./client-type-update.vue?vue&type=script&lang=js&"
export * from "./client-type-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports